import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { MatIcon } from '@angular/material/icon';
import { Group } from '../../../core/models/group.interface';
import { Profile } from '../../../core/models/users.interface';
import { dualListSettings } from '../../../../main';
import { GroupService } from '../../../core/services/group/group';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { LoadingService } from '../../../core/services/loading/loading';
@Component({
  selector: 'app-group-assign',
  imports: [AngularDualListBoxModule, MatIcon],
  templateUrl: './group-assign.html',
  styleUrl: './group-assign.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupAssign {
  groups: Group[] = [];
  selected: Group[] = [];
  profile: Profile | null = null;
  format = dualListSettings;
  @Input() filtro: string = '';
  @Input() orden: string = '';
  limit = 10;
  total = 0;
  errorMsg: string[] | null = null;

  constructor(
    private groupService: GroupService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private loadingService: LoadingService,
    private dialogRef: MatDialogRef<GroupAssign>,
    @Inject(MAT_DIALOG_DATA) data: { profile: Profile | null },
  ) {
    this.profile = data.profile;
  }

  ngOnInit(): void {
    this.fetchGroups();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  fetchGroups() {
    this.groupService.getGrupos().subscribe((groups) => {
      this.groups = [...groups];

      if (this.profile) {
        this.selected = [...(this.profile.role_group ?? [])];
      }

      this.cdr.markForCheck();
    });
  }

  onSubmit() {
    if (!this.profile) return;

    const payload = {
      profile: this.profile,
      groups: this.selected,
    };

    this.loadingService.show(true);
    this.groupService.assignGroup(payload).subscribe({
      next: () => {
        this.loadingService.show(false);
        this.toastr.success('Los grupos fueron actualizados correctamente!', 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        this.loadingService.show(false);
        this.toastr.error(
          'Error: ' + (err.error?.error ?? err.error?.detail ?? err.message),
          undefined,
          {
            progressBar: true,
            timeOut: 5000,
          },
        );
      },
    });
  }
}
